import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { FitnessClassesDataService, FitnessClassesColumnsService } from '../../../services';
import { FitnessClass, FitnessClassesResult } from '../../../interfaces';
import { Editor } from 'primeng/editor';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EditorService } from '../../../../services/editor/editor.service';
import { DialogFilerComponent } from '../../filer/filer.component';

@Component({
  selector: 'app-fitness-class-form',
  templateUrl: './fitness-class-form.component.html',
  styleUrls: ['./fitness-class-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class FitnessClassFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public fitnessClass: FitnessClass = {};
  public fitnessClassForm: FormGroup = new FormGroup({});
  public fitnessClasses: FitnessClass[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  public Editor = ClassicEditor;
  private filerDialog: DynamicDialogRef = new DynamicDialogRef();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private fitnessClassesDataService: FitnessClassesDataService,
    public fitnessClassesColumnsService: FitnessClassesColumnsService,
    public editorService: EditorService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'FitnessClassFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Fitness Class - Edit');
        this.getFitnessClass(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.fitnessClass !== 'undefined') {
      this.fitnessClass = this.dynamicDialogConfig.data.fitnessClass;
    }
    if (typeof this.fitnessClass.id === 'undefined' || this.fitnessClass.id === null) {
      this.fitnessClass.id = null;
      this.fitnessClass.isPublished = false;
    }
    this.getFitnessClasses();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'FitnessClassFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'FitnessClassFormComponent');
  }

  getFitnessClass(id: number): void {
    this.isLoading = true;
    this.fitnessClassesDataService.getFitnessClass(id).subscribe((response: FitnessClass|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.fitnessClass = response;
        this.prepareFrom();
      }
    });
  }

  getFitnessClasses(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.fitnessClasses !== 'undefined' && this.dynamicDialogConfig.data.fitnessClasses.length > 0) {
      this.fitnessClasses = this.dynamicDialogConfig.data.fitnessClasses;
      return;
    }
    this.fitnessClassesDataService.getFitnessClasses(this.parameters).subscribe((response: FitnessClassesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.fitnessClasses = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.fitnessClassForm = new FormGroup({
      id: new FormControl(this.fitnessClass.id, []),
      name: new FormControl(this.fitnessClass.name, [Validators.required, ]),
      nameAr: new FormControl(this.fitnessClass.nameAr, []),
      nameFr: new FormControl(this.fitnessClass.nameFr, []),
      picture: new FormControl(this.fitnessClass.picture, []),
      mobilePicture: new FormControl(this.fitnessClass.mobilePicture, []),
      title: new FormControl(this.fitnessClass.title, []),
      titleAr: new FormControl(this.fitnessClass.titleAr, []),
      titleFr: new FormControl(this.fitnessClass.titleFr, []),
      content: new FormControl(this.fitnessClass.content, []),
      contentAr: new FormControl(this.fitnessClass.contentAr, []),
      contentFr: new FormControl(this.fitnessClass.contentFr, []),
      icon: new FormControl(this.fitnessClass.icon, []),
      color: new FormControl(this.fitnessClass.color, []),
      sport: new FormControl((typeof this.fitnessClass.sport === 'number') ? this.fitnessClass.sport : this.fitnessClass.sport?.id, [Validators.required, ]),
      ageRange: new FormControl((typeof this.fitnessClass.ageRange === 'number') ? this.fitnessClass.ageRange : this.fitnessClass.ageRange?.id, [Validators.required, ]),
      intensity: new FormControl((typeof this.fitnessClass.intensity === 'number') ? this.fitnessClass.intensity : this.fitnessClass.intensity?.id, [Validators.required, ]),
      classDuration: new FormControl((typeof this.fitnessClass.classDuration === 'number') ? this.fitnessClass.classDuration : this.fitnessClass.classDuration?.id, [Validators.required, ]),
      isPublished: new FormControl(this.fitnessClass.isPublished, [Validators.required, ]),
      fitnessGoals: new FormControl(((typeof this.fitnessClass.fitnessGoals === 'undefined') ? [] : this.fitnessClass.fitnessGoals as any[]).map((item: any) => { return (typeof item === 'number') ? item : item.id; }), []),
    });
  }

  list() {
    this.router.navigate(['/fitness-classes']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.fitnessClassForm.controls).forEach((field: any) => {
        const control = this.fitnessClassForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.fitnessClassForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.fitnessClass = this.fitnessClassForm.value;
    this.disableSubmit = true;
    console.log('fitnessClass', this.fitnessClass);
    if (typeof this.fitnessClass.id !== 'undefined' && this.fitnessClass.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.fitnessClassesDataService.updateFitnessClass(this.fitnessClass).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('FITNESSCLASSUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('FITNESSCLASSNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.fitnessClassesDataService.addFitnessClass(this.fitnessClass).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('FITNESSCLASSCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('FITNESSCLASSNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

  toggleAllFitnessGoals(event: any) {
    const control = this.fitnessClassForm.get('fitnessGoals');
    if (control !== null) {
      if (event.checked)  {
        control.setValue(this.fitnessClassesColumnsService.fitnessGoalsFiltered.map((item: any) => { return item.id; }));
      } else {
        control.setValue([]);
      }
    }
  }

  setColor(event: any) {
    const control = this.fitnessClassForm.get('color');
    if (control !== null) {
      control.setValue(event.value);
    }
  }

  openFilerDialog(field: string): void {
    let url = '';
    const control = this.fitnessClassForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'fitness-classes',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.fitnessClassForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

}

@Component({
  selector: 'app-fitness-class-form',
  templateUrl: './fitness-class-form.component.html',
  styleUrls: ['./fitness-class-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogFitnessClassFormComponent extends FitnessClassFormComponent {
}

